export default function save() {
    return null; // Dynamic block rendered by PHP
}
